module.exports = __webpack_public_path__ + "static/media/buxom.f1c8a04e.png";